import React, { useEffect, useState } from 'react'
import { AppDispatch, RootState } from '../../../redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { emptyTitleListSalesRecord, FetchTitleListSalesRecord, updateMonthsByYear } from '../../../redux/reducers/titleListSalesReducer'
import SelectList, { components } from "react-select";
import { salesTabs } from '../constants/statsConstants';
import StatsContainer from './stats/StatsContainer';
import { FaMinusCircle, FaPlusCircle } from 'react-icons/fa';
import { FetchTitleListYTDSalesRecord } from '../../../redux/reducers/titleListYTDSalesReducer';
import { formatCurrency, formatCurrencyOne, formatValue } from '../../../common-components/commonFunctions';
import { OptionType } from '../../TMM/commonInterfaceTypes';
import { valueContainerCSS } from 'react-select/dist/declarations/src/components/containers';
import AccountSales from './AccountSales';

interface salesDetailsProps {
    selectedIsbn?: string | null;
    selectedIsbnOption?: OptionType | null;
    selectedTitleOption?: OptionType | null;
    DetailData?: any;
}
const SalesDetails: React.FC<salesDetailsProps> = ({ selectedIsbn, selectedIsbnOption, selectedTitleOption, DetailData: DetailDataProp }) => {
    const titleSales = useSelector((state: RootState) => state.titleSalesReducer)
    const dispatch = useDispatch<AppDispatch>();
    const DetailDataFromRedux = useSelector(
        (state: RootState) => state.detailPageReducer.data
    );
    // Use prop if provided, otherwise use Redux data
    const DetailData = DetailDataProp || DetailDataFromRedux;
    const [expandedYears, setExpandedYears] = useState<string[]>([]);
    const [selectedYear, setSelectedYear] = useState<OptionType | null>();
    const [selectedMonth, setSelectedMonth] = useState<OptionType | null>();

    const [selectedSale, setSelectedSale] = useState<string>()

    useEffect(() => {
        setSelectedYear(null)
        setSelectedMonth(null)
    }, [selectedIsbn])


    useEffect(() => {
        if (selectedIsbn && selectedIsbn?.length > 1) {
            dispatch(FetchTitleListSalesRecord({ SelectedEbookIsbn: selectedIsbn, selectedYear: selectedYear?.value, selectedMonth: selectedMonth?.value }))
        }
    }, [selectedIsbn, selectedYear, selectedMonth])

    const toggleYear = (year: any) => {
        setExpandedYears((prev) =>
            prev.includes(year) ? prev.filter((y) => y !== year) : [...prev, year]
        );
    };

    return (
        <div className="w-full mt-0 ">
             <StatsContainer tabs={salesTabs} selectedYear={selectedYear?.label ?? null} selectedMonth={selectedMonth?.label ?? null} />
            <div className='w-full bg-[#e31c23] py-1 mb-1 text-sm font-bold text-center text-white'>Sales By Month/Year</div>
            <div className='w-full border-2 border-gray-300 p-1'>
                <div className='max-h-[400px] overflow-y-auto border border-solid border-gray-300 w-full flex flex-col items-center'>
                    <table className="border-collapse border border-gray-400 w-full">
                        <thead className="w-full bg-white">
                            <tr>
                                <th className="border-2 border-gray-400 p-1" colSpan={12}>
                                    <div className="flex gap-2">
                                        <SelectList
                                            classNamePrefix="custom-select"
                                            isClearable={!!selectedYear?.value?.length}
                                            placeholder={"Year"}
                                            value={selectedYear}
                                            noOptionsMessage={() => "Year not found"}
                                            options={titleSales.data.map(sale => ({ value: sale.year, label: sale.year }))}
                                            onChange={e => {
                                                setExpandedYears([])
                                                if (e) {
                                                    setSelectedYear(e)
                                                    dispatch(updateMonthsByYear(e))
                                                } else {
                                                    dispatch(updateMonthsByYear(""))
                                                    setSelectedYear(null)
                                                }
                                            }}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    minHeight: "32px",
                                                    height: "32px",
                                                }),
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    padding: "2px 8px",
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    margin: "0px",
                                                }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isSelected ? '#E6E6E6' : "",
                                                    color: state.isSelected ? "black" : "black",
                                                    padding: "4px 8px",
                                                    fontSize: "14px",
                                                    cursor: "pointer"
                                                }),
                                                menuList: (provided) => ({
                                                    ...provided,
                                                    padding: 0,
                                                    maxHeight: "120px",
                                                }),
                                                dropdownIndicator: (provided) => ({
                                                    ...provided,
                                                    cursor: "pointer",
                                                    padding: "4px",
                                                }),
                                                clearIndicator: (provided) => ({
                                                    ...provided,
                                                    cursor: "pointer",
                                                    padding: "4px",
                                                }),
                                            }}
                                        />
                                        <SelectList
                                            classNamePrefix="custom-select"
                                            isClearable={!!selectedMonth?.value?.length}
                                            placeholder={"Month"}
                                            noOptionsMessage={() => "Month not found"}
                                            options={titleSales.salesMonths.map(month => ({ value: month, label: month }))}
                                            onChange={(e) => {
                                                e ? setSelectedMonth(e) : setSelectedMonth(null)
                                                setExpandedYears([])
                                            }}
                                            value={selectedMonth}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    minHeight: "32px",
                                                    height: "32px",
                                                }),
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    padding: "2px 8px",
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    margin: "0px",
                                                }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isSelected ? '#E6E6E6' : "",
                                                    color: state.isSelected ? "black" : "black",
                                                    padding: "4px 8px",
                                                    fontSize: "14px",
                                                    cursor: "pointer"
                                                }),
                                                menuList: (provided) => ({
                                                    ...provided,
                                                    padding: 0,
                                                    maxHeight: "120px",
                                                }),
                                                dropdownIndicator: (provided) => ({
                                                    ...provided,
                                                    cursor: "pointer",
                                                    padding: "4px",
                                                }),
                                                clearIndicator: (provided) => ({
                                                    ...provided,
                                                    cursor: "pointer",
                                                    padding: "4px",
                                                }),
                                            }}
                                        />
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th className="text-center border-2 border-gray-400 p-1 w-[130px]" rowSpan={2}>Years / Months</th>
                                <th className="text-center border-2 border-gray-400 p-1" colSpan={2}>Gross Sales</th>
                                <th className="text-center border-2 border-gray-400 p-1" colSpan={2}>Returns</th>
                                <th className="text-center border-2 border-gray-400 p-1" colSpan={2}>Net Sales</th>
                                <th className="text-center border-2 border-gray-400 p-1" colSpan={2}>Non - Bill</th>
                            </tr>
                            <tr>
                                <th className="border-2 border-gray-400 p-1">Units</th>
                                <th className="border-2 border-gray-400 p-1">$</th>
                                <th className="border-2 border-gray-400 p-1">Units</th>
                                <th className="border-2 border-gray-400 p-1">$</th>
                                <th className="border-2 border-gray-400 p-1">Units</th>
                                <th className="border-2 border-gray-400 p-1">$</th>
                                <th className="border-2 border-gray-400 p-1">Units</th>
                                <th className="border-2 border-gray-400 p-1">$</th>
                            </tr>
                        </thead>
                        <tbody>
                            {titleSales.data?.length ?
                                titleSales.data.map((sale, index) => (
                                    <React.Fragment key={index}>
                                        <tr
                                            className="bg-gray-200 font-bold cursor-pointer"
                                            onClick={() => toggleYear(sale.year)}
                                        >
                                            <td className="border border-gray-400 p-1 text-center">
                                                <p className='gap-2 flex justify-center items-center'><span>{sale.year}</span> <span> {expandedYears.includes(sale.year) ? <FaMinusCircle /> : <FaPlusCircle />}</span></p>
                                            </td>
                                            {/* Gross Sales - Units */}
                                            <td className="border border-gray-400  p-1 text-center">
                                                {formatCurrencyOne(sale.months.reduce((acc, month) =>
                                                    acc + month.data.reduce((SelectedAcc, selectedMonth) =>
                                                        Number(SelectedAcc) + Number(selectedMonth.Gross_Units), 0)
                                                    , 0))}
                                            </td>
                                            {/* Gross Sales - Dollars */}
                                            <td className="border border-gray-400 p-1 text-center">
                                                {formatCurrency(
                                                    Math.round(
                                                        sale.months.reduce(
                                                            (acc, month) =>
                                                                acc +
                                                                month.data.reduce(
                                                                    (SelectedAcc, selectedMonth) =>
                                                                        Number(SelectedAcc) + Number(selectedMonth.Gross_Dollars),
                                                                    0
                                                                ),
                                                            0
                                                        )
                                                    )
                                                )}
                                            </td>

                                            {/* Returns - Units */}
                                            <td className="border border-gray-400 p-1 text-center ">
                                                {formatCurrencyOne(sale.months.reduce((acc, month) =>
                                                    acc + month.data.reduce((SelectedAcc, selectedMonth) =>
                                                        Number(SelectedAcc) + Number(selectedMonth.Returns_Units), 0)
                                                    , 0))}
                                            </td>
                                            {/* Returns - Dollars */}
                                            <td className="border border-gray-400 p-1 text-center">
                                                {formatCurrency(
                                                    Math.round(
                                                        sale.months.reduce(
                                                            (acc, month) =>
                                                                acc +
                                                                month.data.reduce(
                                                                    (SelectedAcc, selectedMonth) =>
                                                                        Number(SelectedAcc) + Number(selectedMonth.Returns_Dollars),
                                                                    0
                                                                ),
                                                            0
                                                        )
                                                    )
                                                )}
                                            </td>

                                            {/* Net Sales - Units */}
                                            <td className="border border-gray-400 p-1 text-center ">
                                                {formatCurrencyOne(sale.months.reduce((acc, month) =>
                                                    acc + month.data.reduce((SelectedAcc, selectedMonth) =>
                                                        Number(SelectedAcc) + Number(selectedMonth.Net_Units), 0)
                                                    , 0))}
                                            </td>
                                            {/* Net Sales - Dollars */}
                                            <td className="border border-gray-400 p-1 text-center">
                                                {formatCurrency(
                                                    Math.round(
                                                        sale.months.reduce(
                                                            (acc, month) =>
                                                                acc +
                                                                month.data.reduce(
                                                                    (SelectedAcc, selectedMonth) =>
                                                                        Number(SelectedAcc) + Number(selectedMonth.Net_Dollars),
                                                                    0
                                                                ),
                                                            0
                                                        )
                                                    )
                                                )}
                                            </td>
                                            <td className="border border-gray-400 p-1 text-center">
                                                {formatCurrencyOne(sale.months.reduce((acc, month) =>
                                                    acc + month.data.reduce((SelectedAcc, selectedMonth) =>
                                                        Number(SelectedAcc) + Number(selectedMonth.Non_Bill_Units), 0)
                                                    , 0))}
                                            </td>
                                            <td className="border border-gray-400 p-1 text-center">
                                                {formatCurrency(
                                                    Math.round(
                                                        sale.months.reduce(
                                                            (acc, month) =>
                                                                acc +
                                                                month.data.reduce(
                                                                    (SelectedAcc, selectedMonth) =>
                                                                        Number(SelectedAcc) + Number(selectedMonth.Non_Bill_Dollars),
                                                                    0
                                                                ),
                                                            0
                                                        )
                                                    )
                                                )}

                                            </td>

                                        </tr>
                                        {expandedYears.includes(sale.year) &&
                                            sale.months.map((saleMonth, monthIndex) => (
                                                <tr key={monthIndex} className="border border-gray-400">
                                                    <td className="border border-gray-400 p-1 text-center">{`${saleMonth.month} ${sale.year}`}</td>
                                                    {/* Gross Sales - Units */}
                                                    <td className="border border-gray-400 p-1 text-center">
                                                        {formatCurrencyOne(saleMonth.data.reduce((sum, entry) => sum + entry.Gross_Units, 0))}
                                                    </td>
                                                    {/* Gross Sales - Dollars */}
                                                    <td className="border border-gray-400 p-1 text-center">
                                                        {formatCurrency(Math.round((saleMonth.data.reduce((sum, entry) => sum + entry.Gross_Dollars, 0))))}
                                                    </td>

                                                    {/* Returns - Units */}
                                                    <td className="border border-gray-400 p-1 text-center">
                                                        {formatCurrencyOne(saleMonth.data.reduce((sum, entry) => sum + entry.Returns_Units, 0))}
                                                    </td>
                                                    {/* Returns - Dollars */}
                                                    <td className="border border-gray-400 p-1 text-center">
                                                        {formatCurrency(Math.round((saleMonth.data.reduce((sum, entry) => sum + entry.Returns_Dollars, 0))))}
                                                    </td>

                                                    {/* Net Sales - Units */}
                                                    <td className="border border-gray-400 p-1 text-center">
                                                        {formatCurrencyOne(saleMonth.data.reduce((sum, entry) => sum + entry.Net_Units, 0))}
                                                    </td>
                                                    {/* Net Sales - Dollars */}
                                                    <td className="border border-gray-400 p-1 text-center">
                                                        {formatCurrency(Math.round((saleMonth.data.reduce((sum, entry) => sum + entry.Net_Dollars, 0))))}
                                                    </td>

                                                    <td className="border border-gray-400 p-1 text-center">
                                                        {formatValue(saleMonth.data.reduce((sum, entry) => sum + entry.Non_Bill_Units, 0))}
                                                    </td>
                                                    <td className="border border-gray-400 p-1 text-center">
                                                        {formatCurrency(Math.round((saleMonth.data.reduce((sum, entry) => sum + entry.Non_Bill_Dollars, 0))))}
                                                    </td>

                                                </tr>
                                            ))}
                                    </React.Fragment>
                                )) : ""
                            }
                        </tbody>
                    </table>
                    {!titleSales.data?.length ? <div className='text-gray-600 font-semibold text-[14px] py-8'>No Data Found</div> : ""}
                </div>
               
            </div>

            {/* Accounts Sales Section */}
             <div className="w-full mt-4">
                <div className='w-full bg-[#e31c23] py-1 mb-1 text-sm font-bold text-center text-white'>Account Sales</div>
                {/* <div className="w-full border-2 border-gray-300 p-4 flex items-center justify-center">
                    <p className="text-gray-600 font-semibold text-[14px]">
                        coming soon.....
                    </p>
                </div> */}
                <AccountSales 
                    selectedIsbn={selectedIsbn}
                    selectedIsbnOption={selectedIsbnOption}
                    selectedTitleOption={selectedTitleOption}
                    DetailData={DetailData}
                    selectedYear={selectedYear?.value || null}
                    selectedMonth={selectedMonth?.value || null}
                />
            </div>

        </div>
    )
}

export default SalesDetails